import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabase';
import DashboardPage from './DashboardPage';
import { isSignupRefused } from './auth/noAccess';

function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      // A Google account with no light speed account yet: offer the waitlist
      if (isSignupRefused()) {
        navigate('/?noAccess=true', { replace: true });
        return;
      }

      const { data, error } = await supabase.auth.getSession();

      if (error) {
        console.error('Error getting session:', error);
        navigate('/');
        return;
      }

      if (data.session) {
        navigate('/dashboard');
      } else {
        navigate('/');
      }
    };

    handleAuth();
  }, [navigate]);

  // The dashboard's loading state, so signing in lands on a page that's already in place
  return <DashboardPage user={null} authLoading />;
}

export default AuthCallback;